export { default } from "./transitionSlideUp";
